import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

export interface RenameDialogData {
  currentName: string;
  itemType: string; // e.g., 'run', 'profile', 'data assessment', 'anomaly detection run'
  title?: string; // Optional custom title
}

@Component({
  selector: 'app-rename-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  template: `
    <div class="app-dialog rename-dialog">
      <div class="app-dialog__heading">
        <button
          mat-icon-button
          type="button"
          class="rename-dialog-close"
          aria-label="Close"
          (click)="onCancel()">
          <mat-icon>close</mat-icon>
        </button>

        <div class="app-dialog__heading-copy">
          <span class="app-dialog__eyebrow">{{ data.itemType }}</span>
          <div class="app-dialog__title-row">
            <div class="app-dialog__title-copy">
              <h2 mat-dialog-title class="app-dialog__title">{{ data.title || 'Rename ' + data.itemType }}</h2>
              <p>Update the name so it is easier to identify.</p>
            </div>
          </div>
        </div>
      </div>

      <form (ngSubmit)="onSave()" novalidate>
        <mat-dialog-content class="app-dialog__content">
          <section class="app-dialog__section">
            <div class="app-dialog__section-heading">
              <h3>Name</h3>
              <span>Required</span>
            </div>

            <div class="app-dialog__grid">
              <mat-form-field appearance="outline" class="app-dialog__full-width">
                <mat-label>Name</mat-label>
                <input
                  matInput
                  name="newName"
                  [(ngModel)]="newName"
                  placeholder="Enter new name"
                  required>
              </mat-form-field>
            </div>
          </section>
        </mat-dialog-content>

        <mat-dialog-actions class="app-dialog__actions" align="end">
          <button mat-button type="button" (click)="onCancel()">Cancel</button>
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="!newName || newName.trim() === ''">
            Save
          </button>
        </mat-dialog-actions>
      </form>
    </div>
  `,
  styles: [`
    .rename-dialog {
      width: 100%;
    }

    .rename-dialog .app-dialog__content {
      min-width: 0;
      width: 100%;
      box-sizing: border-box;
    }

    .rename-dialog-close {
      position: absolute !important;
      top: 12px !important;
      right: 16px !important;
      z-index: 1;
      color: var(--text-secondary);

      mat-icon {
        width: 24px !important;
        height: 24px !important;
        font-size: 24px !important;
      }
    }
  `]
})
export class RenameDialogComponent {
  newName: string;

  constructor(
    public dialogRef: MatDialogRef<RenameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RenameDialogData
  ) {
    // Initialize with current name
    this.newName = data.currentName || '';
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.newName && this.newName.trim() !== '') {
      this.dialogRef.close(this.newName.trim());
    }
  }
}
